import React, {useEffect, useRef} from 'react';
import './textEditor.css';

import {ReactComponent as BoldIcon} from "../../../images/icons/ui/textEditor/bold.svg";
import {ReactComponent as DividerIcon} from "../../../images/icons/ui/textEditor/divider.svg";
import {ReactComponent as FontSizeIcon} from "../../../images/icons/ui/textEditor/fontSize.svg";
import {ReactComponent as ItalicIcon} from "../../../images/icons/ui/textEditor/italic.svg";


function unwrapSpans(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.tagName === 'SPAN') {
        const parent = node.parentNode;
        while (node.firstChild) {
            parent.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
        return;
    }

    Array.from(node.childNodes).forEach(unwrapSpans);
}

function cleanSelectionSpans(range) {
    const fragment = range.cloneContents();
    Array.from(fragment.childNodes).forEach(unwrapSpans);

    range.deleteContents();
    range.insertNode(fragment);
}

function wrapSelection(newClass) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    if (range.collapsed) return;

    // очищаем вложенные спаны
    cleanSelectionSpans(range);

    // создаем span для выделения
    const span = document.createElement('span');

    // пытаемся объединять классы, если уже есть родительский span
    const existingSpan = range.startContainer.parentNode.closest('span');
    if (existingSpan) {
        const classes = new Set(existingSpan.className.split(' ').filter(Boolean));
        newClass.split(' ').forEach(c => classes.add(c));
        span.className = Array.from(classes).join(' ');
    } else {
        span.className = newClass;
    }

    try {
        range.surroundContents(span);
    } catch {
        const fragment = range.extractContents();
        span.appendChild(fragment);
        range.insertNode(span);
    }

    // восстановление выделения
    selection.removeAllRanges();
    selection.addRange(range);
}



function TextEditor({initText, onChange}) {
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.innerHTML =
                initText ||
                '<span class="text-xl">Заголовок</span><div>Подзаголовок</div>';
        }
    }, []);

    const emitChange = () => {
        if (onChange && editorRef.current) {
            onChange(editorRef.current.innerHTML);
        }
    };

    const setFontSize = (size) => {
        wrapSelection(`text-${size}`);
        emitChange();
    };

    const toggleBold = () => {
        wrapSelection('bold');
        emitChange();
    };

    const toggleItalic = () => {
        wrapSelection('italic');
        emitChange();
    };

    return (
        <div className='TextEditor'>
            <div className='buttons-container'>
                <div className='description'>
                    <span>Чтобы добавить изображение, просто вставьте его в поле для ввода</span>
                    Вы можете менять размер, жирность и начертание выделенного текста
                </div>

                <div className='buttons'>
                    <div className='disabled'>
                        <FontSizeIcon/>
                    </div>

                    <button className='button' onClick={() => setFontSize('xxl')}>XXL</button>
                    <button className='button' onClick={() => setFontSize('xl')}>XL</button>
                    <button className='button' onClick={() => setFontSize('l')}>L</button>
                    <button className='button' onClick={() => setFontSize('m')}>M</button>
                    <button className='button' onClick={() => setFontSize('s')}>S</button>
                    <button className='button' onClick={() => setFontSize('xs')}>XS</button>


                    <DividerIcon/>

                    <button className='button' onClick={toggleBold}>
                        <BoldIcon/>
                    </button>

                    <button className='button' onClick={toggleItalic}>
                        <ItalicIcon/>
                    </button>
                </div>
            </div>

            <div className='editor-container'>
                <div className='label'>Текст статьи</div>

                <div
                    ref={editorRef}
                    className='editor'
                    contentEditable
                    onInput={emitChange}
                    suppressContentEditableWarning
                />
            </div>
        </div>
    );
}

export default TextEditor;
